export const realtimeStatsRTTI = Symbol.for("RealtimeStats");

export const tasksByTimeFactoryRTTI = Symbol.for("TasksByTimeFactory");
export const queueStatsProviderRTTI = Symbol.for("QueueStatsProvider");

export const newableQueueStatsRTTI = Symbol.for("NewableQueueStats");
export const newableTasksByTimeRTTI = Symbol.for("NewableTasksByTime");
